import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import Utils from "utils";
import openNotification from "utils/notification";
import cloneDeep from "lodash";
import SettingVehicleTypeService from "services/SettingVehicleTypeService";

export const getVehicleTypeApi = createAsyncThunk(
  "setting/vehicle-type/getVehicleTypeApi",
  async (data, { rejectWithValue }) => {
    try {
      const response = await SettingVehicleTypeService.getAllVehicleTypeApi();
      return response.data;
    } catch (err) {
      return rejectWithValue(err.message || "Error");
    }
  },
);

export const createVehicleTypeApi = createAsyncThunk(
  "setting/vehicle-type/createVehicleTypeApi",
  async (data, { rejectWithValue }) => {
    try {
      const { onSuccess } = data;
      const payload = cloneDeep(data);
      delete payload.onSuccess;
      const response =
        await SettingVehicleTypeService.createVehicleTypeApi(data);
      if (onSuccess) onSuccess(response);
      openNotification(
        "success",
        Utils.setLocale("admin.settings.popup.notification.success"),
        Utils.setLocale("admin.settings.popup.notification.title"),
      );
      return response.data;
    } catch (err) {
      return rejectWithValue(err.message || "Error");
    }
  },
);

export const updateVehicleTypeApi = createAsyncThunk(
  "setting/vehicle-type/updateVehicleTypeApi",
  async (data, { rejectWithValue }) => {
    try {
      const { onSuccess } = data;
      const payload = cloneDeep(data);
      delete payload.onSuccess;
      const response =
        await SettingVehicleTypeService.updateVehicleTypeApi(data);
      if (onSuccess) onSuccess(response);
      openNotification(
        "success",
        Utils.setLocale("admin.settings.popup.notification.success"),
        Utils.setLocale("admin.settings.popup.notification.title"),
      );
      return response.data;
    } catch (err) {
      return rejectWithValue(err.message || "Error");
    }
  },
);

export const deleteVehicleTypeApi = createAsyncThunk(
  "setting/vehicle-type/deleteVehicleTypeApi",
  async (data, { rejectWithValue }) => {
    try {
      const { onSuccess, id } = data;
      const payload = cloneDeep(data);
      delete payload.onSuccess;
      const response = await SettingVehicleTypeService.deleteVehicleTypeApi(id);
      if (onSuccess) onSuccess(response);
      openNotification(
        "success",
        Utils.setLocale("admin.settings.popup.notification.success"),
        Utils.setLocale("admin.settings.popup.notification.title"),
      );
      return response.data;
    } catch (err) {
      return rejectWithValue(err.message || "Error");
    }
  },
);

const initialState = {
  loading: false,
  dataList: [],
};
export const settingVehicleTypeSlice = createSlice({
  name: "setting-vehicle-type",
  initialState,
  reducers: {
    showLoading: (state) => {
      state.loading = true;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(getVehicleTypeApi.pending, (state) => {
        state.loading = true;
      })
      .addCase(getVehicleTypeApi.fulfilled, (state, action) => {
        state.loading = false;
        state.dataList = action.payload;
      })
      .addCase(getVehicleTypeApi.rejected, (state, action) => {
        state.loading = false;
      })
      .addCase(createVehicleTypeApi.pending, (state) => {
        state.loading = true;
      })
      .addCase(createVehicleTypeApi.fulfilled, (state, action) => {
        state.loading = false;
      })
      .addCase(createVehicleTypeApi.rejected, (state, action) => {
        state.loading = false;
      })
      .addCase(updateVehicleTypeApi.pending, (state) => {
        state.loading = true;
      })
      .addCase(updateVehicleTypeApi.fulfilled, (state, action) => {
        state.loading = false;
      })
      .addCase(updateVehicleTypeApi.rejected, (state, action) => {
        state.loading = false;
      })
      .addCase(deleteVehicleTypeApi.pending, (state) => {
        state.loading = true;
      })
      .addCase(deleteVehicleTypeApi.fulfilled, (state, action) => {
        state.loading = false;
      })
      .addCase(deleteVehicleTypeApi.rejected, (state, action) => {
        state.loading = false;
      });
  },
});

export const { showLoading } = settingVehicleTypeSlice.actions;

export default settingVehicleTypeSlice.reducer;
